<template>
  <div>
    <div
      class="flex items-center text-white px-4 py-3 mb-8"
      role="alert"
      :class="{
        'bg-red-500': notification.type == 'error',
        'bg-green-500': notification.type == 'success',
      }"
    >
      <i
        v-if="notification.type == 'error'"
        class="fas fa-exclamation-triangle"
      ></i>
      <i
        v-if="notification.type == 'success'"
        class="fas fa-check"
      ></i>
      <div class="ml-4">
        <span v-html="notification.message">
        </span>
      </div>
      <div v-if="notification.errors && notification.errors.length">
        <div
          v-for="(er, index) in notification.errors"
          :key="`error-${index}`"
        >
          {{ er[0] }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      timeout: null,
    };
  },
  mounted() {
    this.timeout = setTimeout(() => {
      this.remove(this.notification);
    }, 5000);
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
  methods: mapActions("notification", ["remove"]),
};
</script>
